import { render, staticRenderFns } from "./HeroArticleModule.vue?vue&type=template&id=f67ce8e8&"
import script from "./HeroArticleModule.ts?vue&type=script&lang=ts&"
export * from "./HeroArticleModule.ts?vue&type=script&lang=ts&"
import style0 from "./HeroArticleModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports